/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente_bZ_98_90 as Componente_bZ_98_90,
  rec_Componente_xZ_120_90 as Componente_xZ_120_90,
  rec_EstadoError as EstadoError,
  rec_FormularioSolicitante as FormularioSolicitante,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_Ti as Ti,
  rec_api as api,
  rec_wi as wi,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function SolicitantesMovilidad() {
  let e = Go(),
    [t, n] = (0, React.useState)([]),
    [r, i] = (0, React.useState)([]),
    [a, o] = (0, React.useState)([]),
    [s, c] = (0, React.useState)(!0),
    [l, u] = (0, React.useState)(``),
    [f, p] = (0, React.useState)(null),
    m = (0, React.useCallback)(async () => {
      c(!0);
      try {
        let [e, t, r] = await Promise.all([
          api(`/transporte/numeros`),
          api(`/transporte/sedes`),
          api(`/transporte/areas`),
        ]);
        (n(e),
          i(t.filter((e) => e.activo)),
          o(r.filter((e) => e.activo)),
          u(``));
      } catch (e) {
        u(e.message);
      } finally {
        c(!1);
      }
    }, []);
  return (
    (0, React.useEffect)(() => {
      m();
    }, [m]),
    (
      <section
        className={`${Bo} flex flex-col gap-3`}
        children={[
          <div
            className={`flex items-start justify-between gap-3`}
            children={[
              <div
                children={[
                  <p
                    className={`font-medium text-(--text-h)`}
                    children={`Quién puede pedir`}
                  />,
                  <p
                    className={`text-sm text-(--text)`}
                    children={`Solo estos números. A cualquier otro, el bot no le responde.`}
                  />,
                ]}
              />,
              <button
                type={`button`}
                onClick={() => p({})}
                className={zo}
                children={[
                  <Ti className={`mr-1 inline h-3.5 w-3.5`} />,
                  ` Nueva persona`,
                ]}
              />,
            ]}
          />,
          <EstadoError mensaje={l} onReintentar={m} />,
          s ? (
            <Componente_bZ_98_90 />
          ) : t.length === 0 ? (
            <Componente_xZ_120_90
              texto={`Todavía no hay nadie. Agregá a quien va a pedir movilidad.`}
            />
          ) : (
            <ul
              className={`flex flex-col gap-2`}
              children={t.map((e) => (
                <li
                  key={e.id}
                  className={`flex items-center gap-3 rounded-xl border border-(--border) p-3`}
                  children={[
                    <div
                      className={`min-w-0 flex-1`}
                      children={[
                        <p
                          className={`truncate text-sm text-(--text-h)`}
                          children={e.nombre}
                        />,
                        <p
                          className={`truncate text-xs text-(--text)`}
                          children={[
                            e.telefono,
                            ` · `,
                            e.sedes || `sin sedes, todavía no puede pedir`,
                          ]}
                        />,
                        <p
                          className={`truncate text-xs text-(--text)`}
                          children={e.areas || `Cualquier área`}
                        />,
                      ]}
                    />,
                    !e.activo && (
                      <span
                        className={`rounded-full bg-(--panel) px-2 py-0.5 text-[10px] uppercase text-(--text)`}
                        children={`inactivo`}
                      />
                    ),
                    <button
                      type={`button`}
                      onClick={() =>
                        p({
                          editar: e,
                        })
                      }
                      aria-label={`Editar a ${e.nombre}`}
                      className={`rounded-lg p-2 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                      children={(0, JSXRuntime.jsx)(wi, {
                        className: `h-3.5 w-3.5`,
                      })}
                    />,
                  ]}
                />
              ))}
            />
          ),
          f && (
            <FormularioSolicitante
              editar={f.editar}
              sedes={r}
              areas={a}
              onClose={() => p(null)}
              onGuardado={() => {
                (p(null), e.ok(`Cambios guardados`), m());
              }}
            />
          ),
        ]}
      />
    )
  );
}
